import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
}

// Client-side Supabase client using @supabase/ssr with proper cookie configuration
export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey, {
  cookies: {
    getAll() {
      if (typeof document === 'undefined') return [];
      return document.cookie.split(';').map((cookie) => {
        const [name, ...rest] = cookie.trim().split('=');
        return { name, value: decodeURIComponent(rest.join('=')) };
      });
    },
    setAll(cookiesToSet: Array<{ name: string; value: string; options?: any }>) {
      if (typeof document === 'undefined') return;
      cookiesToSet.forEach(({ name, value, options }) => {
        let cookieString = `${name}=${encodeURIComponent(value)}; Path=${options?.path || '/'}; Secure; SameSite=None`;

        if (options?.maxAge) {
          cookieString += `; max-age=${options.maxAge}`;
        }
        if (options?.domain) {
          cookieString += `; domain=${options.domain}`;
        }
        if (options?.expires) {
          cookieString += `; expires=${options.expires}`;
        }
        document.cookie = cookieString;
      });
    },
  },
});

// Export a function that creates a new Supabase client
export const createClient = () => {
  return createBrowserClient(supabaseUrl, supabaseAnonKey, {
    cookies: {
      getAll() {
        if (typeof document === 'undefined') return [];
        return document.cookie.split(';').map((cookie) => {
          const [name, ...rest] = cookie.trim().split('=');
          return { name, value: decodeURIComponent(rest.join('=')) };
        });
      },
      setAll(cookiesToSet: Array<{ name: string; value: string; options?: any }>) {
        if (typeof document === 'undefined') return;
        cookiesToSet.forEach(({ name, value, options }) => {
          let cookieString = `${name}=${encodeURIComponent(value)}; Path=${options?.path || '/'}; Secure; SameSite=None`;

          if (options?.maxAge) {
            cookieString += `; max-age=${options.maxAge}`;
          }
          if (options?.domain) {
            cookieString += `; domain=${options.domain}`;
          }
          if (options?.expires) {
            cookieString += `; expires=${options.expires}`;
          }
          document.cookie = cookieString;
        });
      },
    },
  });
};